<div class="container pb-2">
  <div class="flex flex-col justify-between items-stretch gap-4 p-3 rounded-2xl bg-white shadow-sm">
    <div class="w-full relative z-0 flex justify-start items-center space-x-3">
      <div #hotel (click)="changeAccommodation('hotel', hotel.clientWidth)" routerLinkActive="activeAccomodation"
        [routerLinkActiveOptions]="{exact: true}" routerLink=""
        class="w-32 cursor-pointer hover:bg-slate-100 transition-colors duration-200 rounded-full text-[--primary-color] flex justify-center items-center">
        <span>
          <i class="mr-2 ico-Building text-lg text-gray-500"></i>
        </span>
        <span>هتل</span>
      </div>
      <div #ecolodge (click)="changeAccommodation('ecolodge', ecolodge.clientWidth)"
        routerLinkActive="activeAccomodation" [routerLinkActiveOptions]="{exact: true}" routerLink="/ecolodge"
        class="w-32 cursor-pointer hover:bg-slate-100 transition-colors duration-200 rounded-full text-[--primary-color] flex justify-center items-center relative">
        <!-- <div
          class="rounded-full w-16 h-7 absolute -top-5 -right-6 bg-red-100 flex justify-between items-center text-red-500 px-2 transition-all duration-300">
          <img src="../../../../../assets/images/ecolodge-new.svg" />
          <span class="font-extrabold ecolodge-new-banner">جدید</span>
        </div> -->
        <span>
          <i class="mr-2 ico-Ecotourism-line text-lg text-gray-500"></i>
        </span>
        <span>ویلا و اقامتگاه</span>
      </div>
      <div class="w-full h-[2px] bg-slate-200 rounded-lg absolute -bottom-2 !duration-300 shadow-inner">
        <div [style.right.px]="activeAccomodationNavigator().position"
          [style.width.px]="activeAccomodationNavigator().width"
          class="contents[''] bg-blue-500 h-[2px] absolute bottom-0 right-0 rounded-lg !shadow-2xl !shadow-red-800 !duration-300">
        </div>
      </div>
    </div>
    <div class="iho-autocomplete">
      <div ihoAutocomplete [isMobile]="true">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="!font-medium text-black-500">
            {{searchBoxService.accommodation() == 'ecolodge' ? 'نام شهر یا کد آگهی' : 'مقصد یا هتل'}}
          </mat-label>
          <input matInput class="!font-bold"
            [value]="autocompleteService._selectedItem().name !== undefined ? autocompleteService._selectedItem().name : ''"
            readonly autocomplete="off">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Location text-xl text-gray-500"></i>
          </mat-icon>
        </mat-form-field>
      </div>
      <div [class.hidden]="autocompleteService._state() === 'hide' ? true : false"
        class="w-full h-[100vh] bg-white fixed top-0 right-0 z-10 mobile">
        <iho-autocomplete />
      </div>
    </div>
    <div class="iho-datepicker ">
      <div ihoDatepicker [isMobile]="true">
        <div class="flex justify-between gap-4">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>
              <span class="text-[16px] text-black-500 font-normal mr-3">تاریخ ورود</span>
            </mat-label>
            <input matInput class="!font-bold" [value]="datepickerService._customStartDate()" readonly
              autocomplete="off">
            <mat-icon matPrefix>
              <i class="mr-2 ico-Calender text-xl text-gray-500"></i>
            </mat-icon>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>
              <span class="text-[16px] text-black-500 font-normal mr-3">تاریخ خروج</span>
            </mat-label>
            <input matInput class="!font-bold" [value]="datepickerService._customEndDate()" readonly autocomplete="off">
            <mat-icon matPrefix>
              <i class="mr-2 ico-Calender text-xl text-gray-500"></i>
            </mat-icon>
          </mat-form-field>
        </div>
      </div>
      <div [class.hidden]="!datepickerService._state()" class="w-full h-[100vh] bg-white fixed top-0 right-0 z-10">
        <ng-container *ngComponentOutlet="csrStatus()"></ng-container>
      </div>
    </div>
    <button (click)="search()"
      class="w-full py-2 bg-blue-500 rounded-lg shadow-sm md:rounded-[1.7rem] font-semibold text-white text-xl hover:bg-blue-600 duration-100 transition-all"
      color="accent">
      جستجو
    </button>
  </div>
</div>

<!-- <mat-tab-group animationDuration="0ms" (selectedTabChange)="toggleTab($event)">
    <mat-tab>
        <ng-template mat-tab-label>
            <div class="flex items-center gap-2">
                <i class="ico-Bed !text-2xl"></i>
                <span>
                    هتل
                </span>
            </div>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <div class="flex items-center gap-2">
                <i class="ico-Ecotourism !text-2xl"></i>
                <span>
                    ویلا و اقامتگاه
                </span>
            </div>
        </ng-template>
    </mat-tab>
</mat-tab-group>
<div *ngIf="selectedTab === 0" class="container pb-2">
    <div
        class="flex flex-col justify-between items-stretch gap-2 p-3 rounded-2xl bg-white border border-solid shadow-sm">
        <mat-button-toggle-group>
            <mat-button-toggle disableRipple checked value="iransHotel">
                هتل‌های داخلی
            </mat-button-toggle>
            <mat-button-toggle disableRipple value="foreignHotels">
                هتل‌های خارجی
            </mat-button-toggle>
        </mat-button-toggle-group>
        <div class="iho-autocomplete">
            <div ihoAutocomplete [isMobile]="true">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>
                        مقصد یا هتل
                    </mat-label>
                    <input matInput class="!font-bold"
                        [value]="autocompleteService._selectedItem().name !== undefined ? autocompleteService._selectedItem().name : ''">
                    <mat-icon matPrefix>
                        <i class="p-2 ico-Location text-xl text-gray-500"></i>
                    </mat-icon>
                </mat-form-field>
            </div>
            <div [class.hidden]="autocompleteService._state() === 'hide' ? true : false"
                class="w-full h-[100vh] bg-white fixed top-0 right-0 z-10">
                <iho-autocomplete />
            </div>
        </div>
        <div class="iho-datepicker">
            <div ihoDatepicker [isMobile]="true">
                <div class="flex justify-between gap-2">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>
                            تاریخ ورود
                        </mat-label>
                        <input matInput class="!font-bold" [value]="datepickerService._startDate()">
                        <mat-icon matPrefix>
                            <i class="p-2 ico-Calender text-xl text-gray-500"></i>
                        </mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>
                            تاریخ خروج
                        </mat-label>
                        <input matInput class="!font-bold" [value]="datepickerService._endDate()">
                        <mat-icon matPrefix>
                            <i class="p-2 ico-Calender text-xl text-gray-500"></i>
                        </mat-icon>
                    </mat-form-field>
                </div>
            </div>
            <div [class.hidden]="!datepickerService._state()"
                class="w-full h-[100vh] bg-white fixed top-0 right-0 z-10">
                <iho-datepicker />
            </div>
        </div>
        <button (click)="search()" class="w-full py-2 font-bold bg-yellow-400 rounded-lg shadow-sm" color="accent">
            جستجو
        </button>
    </div>
</div>
<div *ngIf="selectedTab === 1" class="container pb-2">
    <div
        class="flex flex-col justify-between items-stretch gap-2 p-3 rounded-2xl bg-white border border-solid shadow-sm">
        ویلا و اقامتگاه
    </div>
</div> -->